<template>
  <div>
    <Header></Header>
    <div class="background" v-for="(list, index) in lists" :key="index">
      <div class="details_top">
        <div class="details-cont">
          <div class="left">
            <img class="portrait" :src="list.image" alt />
            <div>
              <p class="name">{{ list.name }}</p>
              <p class="chenghu">{{ list.the_title }}</p>
              <p class="jianjie">{{ list.intro }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 身体 -->
      <div class="st">
        <div class="left">
          <div class="left-nav">
            <div class="cont">
              <ul>
                <li class="active">专家介绍</li>
              </ul>
              <div @click="shareToQQ" class="fenxiang">
                <img src="../../assets/img/w_fx.png" alt />
                <span>分享</span>
              </div>
            </div>
          </div>
          <div class="left-cont">
            <!-- <div class="zhdf" v-html="list.intro">{{list.intro}}</div> -->
            <img :src="list.intro_image" alt />
          </div>
        </div>
        <div class="right">
          <div class="xgpc">
            <div class="title1">费用说明</div>
            <div
              class="price"
              v-for="(item, index) in items"
              :key="index"
              @mouseenter="enter(index, item)"
              @mouseleave="leave()"
            >
              <div>
                ￥{{ item.price }}/
                <span>{{ item.cs }}</span>
              </div>
              <div v-show="seen && index == current">
                <span class="jia" @click="reduceCartNum(item, index)">-</span>
                <span class="num">{{ item.buy_num }}</span>
                <span class="jia" @click="addCartNum(item, index)">+</span>
              </div>
            </div>
            <textarea
              v-model="remark"
              id="memo"
              placeholder="写下您的咨询备注…"
              style="
                min-height: 120px;
                min-width: 282px;
                max-height: 120px;
                max-width: 282px;
              "
            ></textarea>
            <div class="gj">
              <div class="feiyong">共计费用：</div>
              <div class="zongji">¥{{ price }}</div>
            </div>
            <div class="btn" @click="zixun(list, index)">开始预约</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 绑定验证手机号 -->
    <div>
      <div class="login" v-show="popup == 2">
        <img src="../../assets/img/dlbg.png" alt />
        <div class="right">
          <img
            class="close"
            src="../../assets/img/xx.png"
            alt
            @click="closepopup"
          />
          <div class="phone">绑定手机号</div>
          <input
            type="text"
            class="int"
            v-model="phone1"
            placeholder="请输入手机号"
          />
          <div class="Password">验证码</div>
          <div class="yzm">
            <input
              type="text"
              class="yzm-i"
              v-model="code2"
              placeholder="请输入验证码"
            />
            <div class="yzm-btn" v-show="show" @click="getyzm">获取验证码</div>
            <div class="yzm-btn djs" v-show="!show">{{ count1 }}s后获取</div>
          </div>
          <div class="phone">密码</div>
          <input
            type="password"
            class="int"
            v-model="password"
            placeholder="请输入密码"
          />
          <div class="Password">邀请码（选填）</div>
          <input
            type="text"
            v-model="invitation"
            class="int"
            placeholder="请输入邀请码"
          />
          <div class="btn" @click="bangding_phone()">立即绑定</div>
        </div>
      </div>
    </div>
    <!--这里是半透明背景层-->
    <div class="over" v-show="popup != 1"></div>
    <Login v-show="popup == 3"></Login>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
import Login from "../popup/login";
export default {
  // 无感刷新引入
  inject: ["reload"],
  name: "",
  data() {
    return {
      seen: false,
      current: 0,
      price: "",
      remark: "",
      type: "2",
      count: "1",
      items: [
        {
          price: "",
          buy_num: "1",
          cs: "小时",
        },
        {
          price: "",
          buy_num: "1",
          cs: "次",
        },
      ],
      id: "",
      lists: [],
      uid: "",
      popup: "1",
      phone1: "", //手机号
      code2: "", //验证码
      password: "", //密码
      invitation: "", //邀请码
      show: true,
      count1: "0", //倒计时
      timer: null,
      code1: "",
    };
  },
  created() {
    var id = this.$route.query.id;
    this.id = id;
    if (JSON.parse(sessionStorage.getItem("data"))) {
      this.uid = JSON.parse(sessionStorage.getItem("data")).id;
    }
  },
  methods: {
    enter(index, item) {
      this.price = item.price;
      this.type = item.buy_num;
      this.items.map((i) => {
        if (item.cs == i.cs) {
          i.buy_num = 1;
          this.count = i.buy_num;
        }
      });
      this.seen = true;
      this.current = index;
    },
    leave() {
      this.seen = false;
      this.current = null;
    },
    addCartNum: function (item, index) {
      if (item.cs == "次") {
        this.type = "1";
      } else {
        this.type = "2";
      }
      var buy_nums = this.items[index].buy_num;
      if (buy_nums > 30) {
        return false;
      }
      this.items[index].buy_num++;
      var num = this.items[index].buy_num;
      this.count = num;
      var price1 = this.items[index].price;
      var zongji = num * price1;
      if (this.items[index].buy_num) {
        this.price = zongji;
        // console.log(this.price);
      }
    },
    reduceCartNum: function (item, index) {
      // console.log(item);
      if (item.cs == "次") {
        this.type = "1";
      } else {
        this.type = "2";
      }
      var buy_nums = this.items[index].buy_num;
      this.count = buy_nums;
      if (buy_nums <= 1) {
        return false;
      }
      this.items[index].buy_num--;
      var num = this.items[index].buy_num;
      this.count = num;
      var price1 = this.items[index].price;
      var zongji = num * price1;
      if (this.items[index].buy_num) {
        this.price = zongji;
        // console.log(this.price);
      }
    },
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "知会教育",
        desc: "知会教育pc端QQ分享",
        share_url: window.location.href,
      };
      location.replace(
        "https://connect.qq.com/widget/shareqq/index.html?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc
      );
    },
    // 咨询老师详情
    async teacher_detail() {
      await this.$service.home
        .teacher_detail({ id: this.id })
        .then((res) => {
          console.log(res.data);
          if (res.data.code == 200) {
            this.lists.push(res.data.content);
            this.price = res.data.content.time_money;
            this.items[0].price = res.data.content.time_money;
            this.items[1].price = res.data.content.number_money;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 开始咨询
    async zixun(list) {
      if (JSON.parse(sessionStorage.getItem("data"))) {
        var if_phone = sessionStorage.getItem("if_phone");
        if (if_phone == 1) {
          await this.$service.home
            .consult_pay({
              id: list.id,
              uid: this.uid,
              type: this.type,
              count: this.count,
              remark: this.remark,
            })
            .then((res) => {
              console.log(res.data);
              if (res.data.code == 200) {
                if (res.data.content.consultmy_id) {
                  this.$alert(
                    "稍后会有工作人员联系您，如有问题请拨打电话：021-20905777",
                    "提示",
                    {
                      confirmButtonText: "确定",
                    }
                  );
                } else {
                  var money = res.data.content.money;
                  var order_id = res.data.content.order_id;
                  this.$router.push({
                    path: "/zx_pay",
                    query: {
                      id: list.id,
                      money: money,
                      order_id: order_id,
                    },
                  });
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.popup = 2;
        }
      } else {
        this.popup = 3;
      }
    },
    // 验证码获取
    async getyzm() {
      if (
        !/^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8,5])|(19[7]))\d{8}$/.test(
          this.phone1
        )
      ) {
        this.$confirm("手机号格式错误")
          .then((_) => {
            done();
          })
          .catch((_) => {});
        return false;
      } else {
        const TIME_COUNT = 60;
        var phone1 = this.phone1;
        if (!this.timer) {
          this.count1 = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count1 > 0 && this.count1 <= TIME_COUNT) {
              this.count1--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        await this.$service.home
          .getyzm({
            phone: phone1,
            type: 1,
          })
          .then((res) => {
            console.log(res);
            if (res.data) {
              if (res.data.code == 200) {
                this.code1 = res.data.content;
              }
            }
            if (res.err) {
              if (res.err.data.code == 201) {
                this.$confirm(res.err.data.msg)
                  .then((_) => {
                    done();
                  })
                  .catch((_) => {});
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 验证手机号
    async bangding_phone() {
      var phone2 = this.phone1;
      var code = this.code2;
      var password = this.password;
      if (phone2 && code && password) {
        await this.$service.home
          .ifcode({
            phone: phone2,
            code: code,
          })
          .then((res) => {
            console.log(res);
            if (res.data) {
              if (res.data.code == 200) {
                this.bangding();
              }
            }
            if (res.err) {
              if (res.err.data.code == 201) {
                this.$confirm(res.err.data.msg)
                  .then((_) => {
                    done();
                  })
                  .catch((_) => {});
              }
            }
          })
          .catch((err) => {});
      } else {
        this.$confirm("必填项不能为空哦")
          .then((_) => {
            done();
          })
          .catch((_) => {});
      }
    },
    // 绑定手机号
    async bangding() {
      var id = JSON.parse(sessionStorage.getItem("data"));
      await this.$service.home
        .bangding_phone({
          uid: id.id,
          phone: this.phone1,
          password: this.password,
          invite_code: this.invitation,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$confirm("绑定成功")
              .then((_) => {
                done();
              })
              .catch((_) => {});
            sessionStorage.setItem("if_phone", 1);
            // 页面无感刷新
            this.reload();
          }
        });
    },
    //关闭弹窗
    closepopup() {
      this.popup = 1;
      // 页面无感刷新
      this.reload();
    },
  },
  components: {
    Header,
    Footer,
    Login,
  },
  mounted() {
    this.teacher_detail();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}
.details_top {
  background-image: url("../../assets/img/bgg.png");
  margin-bottom: 20px;
}
.details_top .details-cont {
  width: 1200px;
  height: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.details_top .details-cont .left {
  width: 492px;
  display: flex;
}
.details_top .details-cont .left .portrait {
  width: 95px;
  height: 120px;
  border-radius: 6px;
  border: 2px solid rgba(255, 255, 255, 1);
  margin-right: 12px;
}
.details_top .details-cont .left div p.name {
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 28px;
  margin-bottom: 6px;
}
.details_top .details-cont .left div p.chenghu {
  min-width: 90px;
  max-width: 500px;
  height: 20px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  margin-bottom: 6px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}
.details_top .details-cont .left div p.jianjie {
  width: 385px;
  height: 60px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}
.details_top .details-cont .right {
  width: 300px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-align: center;
}
.details_top .details-cont .right .kecheng .number,
.details_top .details-cont .right .bofang .number {
  font-size: 36px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  letter-spacing: 2px;
}
.details_top .details-cont .right .line {
  width: 1px;
  height: 48px;
  background: rgba(255, 255, 255, 1);
}
.details_top .details-cont .right .kecheng .title,
.details_top .details-cont .right .bofang .title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  letter-spacing: 1px;
}
/* 身体 */
.background .st {
  width: 1200px;
  margin: 0 auto;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.background .st .left {
  width: 860px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}
.background .st .left ul {
  display: flex;
}
.background .st .left ul li {
  height: 62px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.background .st .left ul li.active {
  color: #1775ef;
}
.background .st .left .left-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ededed;
}
.background .st .left .left-nav .cont {
  margin: 0 auto;
  width: 760px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.background .st .left .left-cont {
  width: 760px;
  margin: 0 auto;
  margin-top: 20px;
}
.background .st .left .left-cont img {
  width: 100%;
  height: 100%;
}
.background .st .left .left-cont .zhdf {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
  margin-bottom: 15px;
}
.background .st .right {
  width: 324px;
  height: 687px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.background .st .right .xgpc {
  width: 290px;
  margin: 0 auto;
  margin-top: 20px;
}
.background .st .right .xgpc .title1 {
  height: 60px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin-bottom: 21px;
  border-bottom: 1px solid #ededed;
}
.background .st .right .xgpc .price {
  width: 284px;
  height: 56px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  margin: 0 0 31px 10px;
  display: flex;
  justify-content: space-between;
}
.background .st .right .xgpc .price .jia {
  display: inline-block;
  width: 18px;
  height: 18px;
  background: rgba(23, 117, 239, 1);
  border-radius: 4px;
  line-height: 15px;
  text-align: center;
  color: #fff;
}
.background .st .right .xgpc .price .num {
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}
.background .st .right .xgpc .price:hover {
  background: rgba(237, 244, 254, 1);
  border-radius: 10px;
}
textarea {
  background: #f3f3f3;
  border: none;
  margin-bottom: 20px;
  border-radius: 10px;
}
textarea::-webkit-input-placeholder {
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  padding: 10px 0 0 10px;
}
.background .st .right .xgpc .gj {
  display: flex;
  justify-content: space-between;
}
.background .st .right .xgpc .gj .feiyong {
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 20px;
}
.background .st .right .xgpc .gj .zongji {
  font-size: 18px;
  font-weight: 500;
  color: rgba(255, 54, 54, 1);
  line-height: 25px;
  margin-bottom: 20px;
}
.background .st .right .xgpc .btn {
  width: 282px;
  height: 40px;
  background: rgba(23, 117, 239, 1);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
}
/* 绑定手机号 */
.over {
  position: fixed;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #111111;
}
.login {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 700px;
  height: 420px;
  background: rgba(255, 255, 255, 1);
  display: flex;
}
.login .right {
  margin-left: 62px;
  margin-top: 16px;
}
.login .right .bot {
  display: flex;
  margin-top: 12px;
}
.login .right .bot .fanhui {
  font-size: 12px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  margin-left: 1px;
}
.login .right .bot img {
  margin-top: 100px;
}
.login .right .bot .fanhui1 {
  font-size: 12px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  margin-top: 100px;
}
.login .right .bot .bot-r {
  display: flex;
  font-size: 12px;
  font-weight: 500;
  margin-left: 62px;
}
.login .right .bot .ty {
  color: rgba(136, 136, 136, 1);
}
.login .right .bot .xieyi {
  color: #1775ef;
}
.login .right .close {
  margin-left: 306px;
}
.login .right .title {
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 22px;
}
.login .right .title1 {
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  margin-bottom: 22px;
}
.login .right .phone,
.login .right .Password {
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  margin-bottom: 6px;
}
.login .right .btn {
  width: 280px;
  height: 46px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  text-align: center;
  line-height: 46px;
  color: #ffffff;
  margin-bottom: 10px;
}
.login .right .register1 {
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 117, 239, 1);
  margin-left: 172px;
}
input::-webkit-input-placeholder {
  padding-left: 10px;
}
.login .right input.int {
  background-color: #f8f8f8;
  width: 280px;
  height: 36px;
  border-radius: 6px;
  border: none;
  margin-bottom: 16px;
}
.login .right .yzm {
  display: flex;
  margin-bottom: 16px;
}
.login .right input.yzm-i {
  width: 168px;
  height: 36px;
  margin-right: 12px;
  background-color: #f8f8f8;
  border-radius: 6px;
  border: none;
}
.login .right .yzm-btn {
  width: 100px;
  height: 36px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  color: #ffffff;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
}
.login .right .djs {
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/zixun/advi_details.vue